import { useEffect, useState } from "react";
import { Table } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { getChangeRequestBysite,fetchAllChangetype } from "../../../store/actions";
import { sitechangerequest_column } from "../../../helpers/columns";
import { MantineGrid, MantineGridColumn } from "../../../components/mantine/grid";
import { PlaceholderUi, useCustomMediaQuery } from "../../../helpers/common";
import { useParams, useNavigate } from 'react-router-dom';
import { useStateContext } from "../../../Contexts/ContextProvider"
import { Link } from "react-router-dom";
import { useDebounce } from "../../../utlis/debounceHook";
import MantineTextInput from "../../../components/mantine/textinput";
import MantineButton from "../../../components/mantine/button";
import MantinePagination from "../../../components/mantine/pagination";
import MantineGroup from "../../../components/mantine/group";
import MantineContainer from "../../../components/mantine/container";
import moment from "moment";
import MantineCloseButton from "../../../components/mantine/closeButton";

export default function ManageDrawingProfile() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<any>('');
  const [pageSize, setPageSize] = useState<any>(5);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activepageNumber, setActivePageNumber] = useState<any>(1);
  const { currentPrimaryColor, currentSecondaryColor, currentTeritorryColor } = useStateContext();
  const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
  const debouncedQuery = useDebounce(searchValue, 500);
  const { getChangeRequest,Count,TypeName } = useSelector((state: any) => ({
    getChangeRequest: state?.getsiteData?.changerequestlist,
    Count: state?.getsiteData?.totalCount,
    TypeName: state?.getManualURL?.Changetypelist 
  }));
  const searchParams: any = useParams();
  //const siteid = searchParams.get('siteId');
  const { siteId } = useParams();
  useEffect(() => {
    getList();
  }, [pageNumber, pageSize, siteId, debouncedQuery]);
  useEffect(() => {
    if (searchValue?.length == 0) {
      const data = {
        "siteId": siteId,
        "pageNumber": activepageNumber,
        "pageSize": pageSize,
        "sortColumn": "",
        "sortDirection": "",
        "searchKeyword": searchValue
      }
      dispatch(getChangeRequestBysite(data))
    }
  }, [searchValue])

  const getList = () => {
    const data = {
      "siteId": siteId,
      "pageNumber": pageNumber,
      "pageSize": pageSize,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getChangeRequestBysite(data))
  }  
  // report download concept
  const getuserReport = (reports: any) => {
    const userdata:any = {
      "siteId": siteId,
      //"pageNumber": pageNumber,
      //"pageSize": pageSize,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue,
      isExport: true
    }
    if (!reports) {
      userdata.pageNumber = pageNumber;
      userdata.pageSize = pageSize;
    }

    if (reports == true) dispatch(getChangeRequestBysite(userdata, "export", `${moment(Date()).format('YYYY_MM_DD')}_changerequest_list`))
  }
  const handlePageSizeChange = (value: string) => {
    setPageSize(Number(value));
  };

  const handleCloseValue = () => {
    setSearchValue('');
  }
  useEffect(() => {
    dispatch(fetchAllChangetype())
  }, [dispatch]);

  
  const rows = getChangeRequest?.map((item: any, index: any) => {
    //const changeTypeName = TypeName?.find((type: any) => type.id === item.changeTypeId)?.name || 'N/A';
    return (
    <Table.Tr key={index}>
      <Table.Td data-label="Site Name">{item.siteName}</Table.Td>
      <Table.Td data-label="Client Name">{item.clientName}</Table.Td>
      <Table.Td data-label="Request Date">{moment(item.requestDate).format('YYYY-MM-DD')}</Table.Td>
      <Table.Td data-label="Applicant Name">{item.applicantName}</Table.Td>
      <Table.Td data-label="Applicant Email">{item.applicantEmail}</Table.Td>
      {/* <Table.Td data-label="ChangeType">{changeTypeName}</Table.Td> */}
      <Table.Td data-label="Uploaded File">{item.fileUploadUrl ? (<Link to={item.fileUploadUrl}>{item.fileUploadUrl} </Link>) : ('N/A')}</Table.Td>
      <Table.Td data-label="Updated Drawing">{item.uploadDrawings ? "Yes" : "No"}</Table.Td>
      <Table.Td data-label="Commissioning Certificate">{item.commissionCertificate ? "Yes" : "No"}</Table.Td>
      <Table.Td data-label="Manufacturer Literature">{item.manufacturersLiterature ? "Yes" : "No"}</Table.Td>
      <Table.Td data-label="Approval Declaration">{item.approveDeclaration ? "Yes" : "No"}</Table.Td>
      <Table.Td data-label="Comments">{item.changeRequestComment}</Table.Td>
    </Table.Tr>
  );
  });

  const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`  // multiple time css call so single line convert
  return (
    <div className="w-full mt-4">
      {/* <MantineTitle order={4} className="m-auto font-semibold text-md text-center">ManageSite ChangeRequest</MantineTitle>  */}
      <MantineContainer fluid={true} className="m-auto bg-white my-6 px-5">
        <MantineGrid className="py-5" grow={true}>
          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }} >
            <form onSubmit={(event: any) => { event.preventDefault(); setPageNumber(1); getList() }}>
              <MantineTextInput
                placeholder={`Search by Name or Email`}
                onChange={(event: any) => { setSearchValue(event.currentTarget?.value) }}
                value={searchValue}
                rightSection={searchValue?.length >= 1 && <MantineCloseButton onClick={() => handleCloseValue()} />}
                classNames={{ input: `${PlaceholderUi}` }}
              />
            </form>
          </MantineGridColumn>
          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }}>
            <MantineButton
              name={'Search'}
              color={currentPrimaryColor}
              className={classButton}
              onClick={() => { getList() }}
            />
          </MantineGridColumn>
          
          <MantineGridColumn span={{ base: 12, md: 6, lg: 6 }}>
            <MantineGroup justify="flex-end">
              <MantineButton
                name={'Export'}
                color={currentPrimaryColor}
                onClick={() => getuserReport(true)}
                className={classButton}
              />
            </MantineGroup>
          </MantineGridColumn>
        </MantineGrid>
      </MantineContainer>
      <MantineContainer fluid={true} className="m-auto bg-white pt-5 px-5 pb-10">
        <div className={`${rows?.length !== 0 && 'mobile-responsive-scroll'}`}>
          <Table className="bg-global_bg" verticalSpacing="sm">
            <Table.Thead>
              <Table.Tr>
                {sitechangerequest_column?.map((data: any) => {
                  return <Table.Th key={data.id}>{data.name}</Table.Th>;
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody className="relative">{rows?.length == 0 ? <div className={`${isLargeScreenmin ? `mt-4 absolute left-1/2 text-center` : 'text-center'}`}>No Data Found</div> : rows}</Table.Tbody>
          </Table>
        </div>
        <MantineGroup className={`justify-end pt-5 ${rows?.length == 0 && isLargeScreenmin && 'pb-8'}`}>
          {rows?.length != 0 &&
            <MantinePagination
              total={Math.ceil(Count/ pageSize)}
              onChange={(value: any) => { setPageNumber(value); setActivePageNumber(value) }}
              color={currentPrimaryColor}
              withEdges={true}
              valueSelect={pageSize}
              size={"md"}
              className='m-auto pb-4'
              onChangeSelect={handlePageSizeChange}
              value={searchValue?.length != 0 ? pageNumber : activepageNumber}
            />
          }
        </MantineGroup>
      </MantineContainer>
    </div>
  );
}
